<script>
  import { format } from 'svelte-i18n';

  import { ActivityEventIcon } from '@client/components/activity-event-icon';
  import { RelativeTime } from '@client/components/relative-time';

  /**
   * @typedef {"adclick" | "attachmentdownload" | "attachmentview" | "beaconview" | "linkclick" | "msg" | "videoactivity" | "websitevisit"} Type
   */

  /**
   * The type of notification.
   * @type {Type}
   */
  export let type = undefined;

  /**
   * The email recipient of the notification.
   * @type {string}
   */
  export let recipient = undefined;

  /**
   * The email subject of the notification.
   * @type {string}
   */
  export let subject = undefined;

  /**
   * Indicates whether the notification is unread.
   * @type {boolean}
   */
  export let unread = false;

  /**
   * The date the notification occurred.
   * @type {Date}
   */
  export let date = undefined;

  // TODO i18n tooltip & verb:
  // TODO merge with enums/activity-events?:
  export const ACTIVITY_EVENTS = {
    adclick: {
      icon: 'target',
      tooltip: $format('label.AD_CLICK'),
      verb: $format('label.CLICKED'),
      color: '#35cd8d'
    },
    attachmentdownload: {
      icon: 'download',
      tooltip: $format('label.DOCUMENT_DOWNLOAD'),
      verb: $format('label.DOWNLOADED'),
      color: '#9A79C5'
    },
    attachmentview: {
      icon: 'external-link',
      tooltip: $format('label.DOCUMENT_VIEW'),
      verb: $format('label.VIEWED'),
      color: '#9A79C5'
    },
    beaconview: {
      icon: 'eye',
      tooltip: $format('label.EMAIL_VIEW'),
      verb: $format('label.VIEWED'),
      color: '#1c90f8'
    },
    linkclick: {
      icon: 'link',
      tooltip: $format('label.LINK_CLICK'),
      verb: $format('label.CLICKED'),
      color: '#50bAb4'
    },
    msg: {
      icon: 'send',
      tooltip: $format('label.EMAIL_SENT'),
      verb: $format('label.SENT'),
      color: '#777777'
    },
    videoactivity: {
      icon: 'video',
      tooltip: $format('label.VIDEO_VIEW'),
      verb: $format('label.VIEWED'),
      color: '#e7ca65'
    },
    websitevisit: {
      icon: 'globe',
      tooltip: $format('label.WEBSITE_VISIT'),
      verb: $format('label.VISITED'),
      color: '#fd8e82'
    }
  };

  $: color = ACTIVITY_EVENTS[type]?.color;
  $: icon = ACTIVITY_EVENTS[type]?.icon;
  $: tooltip = ACTIVITY_EVENTS[type]?.tooltip;
  $: verb = ACTIVITY_EVENTS[type]?.verb;
</script>

<small {...$$restProps} class="notifications-item d-flex align-items-center pb-2 pt-1">
  <ActivityEventIcon {icon} {color} class="me-2" {tooltip} />
  <div class="event d-flex flex-column" class:text-muted={!unread}>
    <b>{recipient}</b>
    {#if subject}
      <span class="text-break">{verb} {subject}</span>
    {/if}
    <sub class="text-muted mt-1">
      <RelativeTime {date} />
    </sub>
  </div>
  {#if unread}
    <span class="text-primary ms-auto" aria-label="Unread">●</span>
  {/if}
</small>

<style>
  .event {
    font-size: 0.7rem;
  }
</style>
